export const serviceIssuesCheckboxesValues = [
  { id: '11012', value: 'Aktive Internetverbindung zu hCONTROL für Remote-Zugriff möglich?' },
  { id: '11013', value: 'Wurde ein Video zum Fehler angehängt?' },
  { id: '11014', value: 'Wurde das Roboter-Programm angehängt?' },
  { id: '11015', value: 'Wurde der Fehlerstatus (horstFX.zip) angehängt?' },
]
